import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import {
  getAutocompleteAction,
  saveRequestAction,
  getSearchAction,
  getRestore, saveFirstSearchData /* removeAction, addSegAction */,
} from "../store/actions/index";
import {
  Grid,
  TextField,
  IconButton,
  Icon,
  Button,
  Hidden,
  Popper,
  Typography,
  FormLabel,
} from "@material-ui/core";
import { FormGroup, FormControlLabel, Link } from "@material-ui/core";
import CheckboxForm from "@material-ui/core/Checkbox";

//import AddIcon from '@material-ui/icons/Add';
//import RemoveIcon from '@material-ui/icons/Remove';
import DeleteIcon from "@material-ui/icons/Delete";
import Datepicker from "../components/Datepicker";
//import FormInput from './../components/FormInput'
import FormInputSelect from "../components/FormInputSelect";
import FormInputRangeAge from "../components/FormInputRangeAge";
//import FormInputText from '../components/FormInputText'
import { getSearchDepartureHour } from "../store/services/InfoFormService";
import CircularProgress from "@material-ui/core/CircularProgress";

//import PopoverSimpleTitleContent from "./../components/PopoverSimpleTitleContent";
//import { ControlPointDuplicateOutlined } from "@material-ui/icons";
//import ResultsPage from "../pages/ResultsPage/ResultsPage";

class SearchTrainsTickets extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    
    this.optionHidden = "";
    this.state = {
      iatafrom: "",
      iatato: "",
      checkin: "",
      request: [
        { origin: {}, destination: {}, departure: "", directOnly: false },
      ],
      tramos: this.props.searchData
        ? this.props.getSearch.tramos
        : [{ time: "0600" }],
      edades: [],
      msgPassenger: false,
      msg: false,
      timeInput: [],
      ages: [],
      departureInput: [],
      adultos: "",
      jovenes: "",
      menores: "",
      loading: false,
      cantPassAdultos: 10,
      cantPassJovenes: 10,
      cantPassMenores: 10,
      cantPass: 0,
      select: 0,
      showDirectBtn: true,
      directOnly: false,
      roundtrip: false,
      dateToInput: [],
      timeInputDateTo: [],
    };
    this.handleCantPasajeros = this.handleCantPasajeros.bind(this);
    this.handlePasajeros = this.handlePasajeros.bind(this);
    this.addTramo = this.addTramo.bind(this);
    this.addEdad = this.addEdad.bind(this);
    this.removeTramo = this.removeTramo.bind();
    this.handleDirectOnlyChange = this.handleDirectOnlyChange.bind(this);
    this.handleSwitchOptionType = this.handleSwitchOptionType.bind(this);
    this.tokenClient = this.props.getSearch.tokenClient
      ? this.props.getSearch.tokenClient
      : this.props.tokenClient;
    this.apiToken = this.props.apiToken;
    this.apiUrl = this.props.apiUrl;
    this.inputsReftOrigin = [...new Array(8)].map(() => React.createRef());
    this.inputsReftDestination = [...new Array(8)].map(() => React.createRef());
    console.log(this.state.tramos)
  }

  handleDirectOnlyChange(event) {
    const { checked } = event.target;
    this.setState({ directOnly: checked });
    // this.props.updateDirectOnly(checked);
  }
  handleSwitchOptionType(event) {
    const { checked } = event.target;
    this.setState({ roundtrip: checked });
  }

  UNSAFE_componentWillMount = () => {
    let adultos = 0;
    let jovenes = 1;
    let menores = 0;
    //let edadesMenores = []
    if (this.props.getSearch.edades[0].ageInput !== "") {
      adultos = 0;
      jovenes = 0;
      menores = 0;
      {
        this.props.getSearch.edades.map((edad, i) => {
          edad.ageInput !== "" && edad.ageInput >= 60
            ? adultos++
            : edad.ageInput < 60 && edad.ageInput > 29
              ? jovenes++
              : edad.ageInput <= 29 && edad.ageInput > 0 && menores++;
        });
      }
    }
    this.setState({ adultos: adultos, jovenes: jovenes, menores: menores });
  };

  UNSAFE_componentWillReceiveProps(next_props) {
    if (this.props.getSearch.edades[0].ageInput !== "")
      this.setState({
        edades: next_props.getSearch.edades.filter(
          (edad) => edad.ageInput <= 29
        ),
      });
  }

  handleChangeAutoComplete = (e, name, indice, value) => {
    //let key = (name === 'cityFrom') ? 'origin' : 'destination';

    // Seteando valores de autocomplete por tramo
    let tramos = this.state.tramos;
    //let request = this.state.request;
    let tramo = this.state.tramos[indice];
    //let object = this.state.request[indice];
    tramo[name] = {
      code: this.optionHidden.split("-")[0],
      type: this.optionHidden.split("-")[1],
      value: value,
    };
    tramos[indice] = tramo;


    //Armando el objeto request que nos sirve para el servicio de resultados
    this.setState((prevState) => ({
      tramos: tramos,
      msg: false,
    }));

    this.props.dispatchGetAutocomplete(value, this.apiUrl);
  };

  addTramo = () => {
    if (this.state.tramos.length === 8) {
    } else {
      this.setState((prevState) => {
        return {
          tramos: [...prevState.tramos, { time: "0600" }],
          // showDirectBtn: false,

          // request: [...prevState.request, { "origin": {}, "destination": {}, "departure": '', "directOnly": false }]
        };
      });
    }
  };

  callback = (value, index, name) => {
    let tramos = this.state.tramos;
    let tramo = this.state.tramos[index];

    if (tramo === undefined) {
      let tramos = this.state.tramos;
      let tramo = this.state.tramos[this.state.tramos.length - 1];
      tramo[name] = value;
      tramos[this.state.tramos.length - 1] = tramo;
      this.setState((prevState) => ({
        tramos: tramos,
      }));
    } else {
      tramo[name] = value;
      tramos[index] = tramo;
      this.setState((prevState) => ({
        tramos: tramos,
      }));
    }
  };

  /*  removeTramo = (index) => { */
  removeTramo = (tramos, index) => {
    if (this.state.tramos.length > 1) {
      delete this.state.tramos[index];
      this.setState({ tramos: this.state.tramos, showDirectBtn: true });
    }
  };
  removeTramo1 = (tramos, index) => {
    if (this.state.tramos.length > 1) {
      const filteredArray = tramos.filter((_, i) => i !== index);

      filteredArray.map((value, i) => {
        this.state.departureInput[i].state.selectedDate =
          filteredArray[i]["departure"];
        this.state.timeInput[i].state.defaultValue = filteredArray[i]["time"];
        this.state.dateToInput[i].state.selectedDate =
          filteredArray[i]["dateTo"];
        this.state.timeInputDateTo[i].state.defaultValue =
          filteredArray[i]["timeDateTo"];
      });

      this.state.tramos = filteredArray;

      this.setState({
        tramos: this.state.tramos,
        departureInput: this.state.departureInput,
        timeInput: this.state.timeInput,
        dateToInput: this.state.dateToInput,
        timeInputDateTo: this.state.timeInputDateTo,
      });
    }
  };

  removeEdad = () => {
    if (this.state.edades.length > 1) {
      this.setState((prevState) => {
        const array = [...prevState.edades];
        array.pop();
        return { edades: array };
      });
    }
  };

  handlePasajeros = (e, value) => {
    let nEdades = e.target.value;
  };

  handleSubmit = (e) => {
    let departure = [];
    let dateOut = [];
    let time = [];
    let ages = [];
    let origin = [];
    let destination = [];
    const array = [];

    e.preventDefault();

    this.props.dispatchGetRestore();

    for (var i = 0; i < this.state.adultos; i++) {
      ages.push("61");
    }
    for (var l = 0; l < this.state.jovenes; l++) {
      ages.push("30");
    }

    /*   for (var x=0; x < this.state.menores; x++) {
             ages.push('12')
          } 
  */

    if (this.state.adultos === 0 && this.state.jovenes === 0) {
      this.setState({ msgPassenger: true });
    }

    if (this.state.menores > 0) {
      this.state.edades.map((value, i) => {
        if (this.state.ages[i].state.defaultValue !== "") {
          if (this.state.ages[i].state.defaultValue < 30) {
            ages.push(this.state.ages[i].state.defaultValue);
          }
        }
      });
    }

    for (var i = 0; i < this.state.tramos.length; i++) {
      if (this.state.tramos[i] === undefined) {
        this.state.tramos.splice(i, 1);
      }
    }

    this.state.tramos.map((value, i) => {
      if (this.state.tramos[i] !== undefined) {
        time.push(value.time);

        departure.push(value.departure.replace("/", "-").replace("/", "-"));
        if (
          value.cityFrom &&
          Object.keys(value.cityFrom).length > 0 &&
          value.cityTo &&
          Object.keys(value.cityTo).length > 0
        ) {
          origin.push(
            value.cityFrom.type.trim() +
            "__" +
            value.cityFrom.code.trim().split("#").join("-")
          );
          destination.push(
            value.cityTo.type.trim() +
            "__" +
            value.cityTo.code.trim().split("#").join("-")
          );
        }
      }
    });

    if (this.state.roundtrip) {
      let vuelta = [
        {
          time: this.state.tramos[0].timeDateTo,
          departure: this.state.tramos[0].dateTo,
          cityFrom: this.state.tramos[0].cityTo,
          cityTo: this.state.tramos[0].cityFrom,
        },
      ];

      vuelta.map((value, i) => {
        if (vuelta[i] !== undefined) {
          time.push(value.time);

          departure.push(value.departure.replace("/", "-").replace("/", "-"));
          if (
            value.cityFrom &&
            Object.keys(value.cityFrom).length > 0 &&
            value.cityTo &&
            Object.keys(value.cityTo).length > 0
          ) {
            origin.push(
              value.cityFrom.type.trim() +
              "__" +
              value.cityFrom.code.trim().split("#").join("-")
            );
            destination.push(
              value.cityTo.type.trim() +
              "__" +
              value.cityTo.code.trim().split("#").join("-")
            );
          }
        }
      });

      if (
        !this.state.msgPassenger &&
        Object.keys(origin).length === 2 &&
        Object.keys(destination).length === 2 &&
        Object.keys(origin).length > 0 &&
        Object.keys(destination).length > 0 &&
        Object.keys(time).length > 0 &&
        Object.keys(ages).length ===
        this.state.adultos + this.state.jovenes + this.state.menores &&
        Object.keys(departure).length > 0
      ) {
        const tramos = this.state.tramos;

        this.props.dispatchGetSearch(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          this.tokenClient,
          this.apiToken,
          this.state.directOnly
        );

        this.props.dispatchSaveFirstSearchData(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          this.tokenClient,
          this.apiToken,
          this.state.directOnly
        );

        time = time.join(",");
        origin = origin.join(",");
        destination = destination.join(",");
        departure = departure.join(",");
        ages = ages.join("-");
        this.props.history.push(
          "/" +
          this.tokenClient +
          "/trenes/results/tickets/" +
          origin +
          "/" +
          destination +
          "/" +
          departure +
          "/" +
          time +
          "/" +
          ages /* ,{tramos:this.state.tramos} */
        );
        this.setState({ loading: true, msg: false });
      }
    } else {
      if (
        !this.state.msgPassenger &&
        Object.keys(origin).length === this.state.tramos.length &&
        Object.keys(destination).length === this.state.tramos.length &&
        Object.keys(origin).length > 0 &&
        Object.keys(destination).length > 0 &&
        Object.keys(time).length > 0 &&
        Object.keys(ages).length ===
        this.state.adultos + this.state.jovenes + this.state.menores &&
        Object.keys(departure).length > 0
      ) {
        const tramos = this.state.tramos;

        this.props.dispatchGetSearch(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          this.tokenClient,
          this.apiToken,
          this.state.directOnly
        );

        this.props.dispatchSaveFirstSearchData(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          this.tokenClient,
          this.apiToken,
          this.state.directOnly
        );

        time = time.join(",");
        origin = origin.join(",");
        destination = destination.join(",");
        departure = departure.join(",");
        ages = ages.join("-");
        this.props.history.push(
          "/" +
          this.tokenClient +
          "/trenes/results/tickets/" +
          origin +
          "/" +
          destination +
          "/" +
          departure +
          "/" +
          time +
          "/" +
          ages /* ,{tramos:this.state.tramos} */
        );
        this.setState({ loading: true, msg: false });
      }
    }
  };

  getSearchSelectAdultos = () => {
    const response = [];
    for (var i = 0; i < this.state.cantPassAdultos; i++) {
      const arrSelect = {};
      arrSelect["code"] = i;
      arrSelect["description"] = i;
      response.push(arrSelect);
    }

    return response;
  };
  getSearchSelectJovenes = () => {
    const response = [];
    for (var i = 0; i < this.state.cantPassJovenes; i++) {
      const arrSelect = {};
      arrSelect["code"] = i;
      arrSelect["description"] = i;
      response.push(arrSelect);
    }

    return response;
  };
  getSearchSelectMenores = () => {
    const response = [];
    for (var i = 0; i < this.state.cantPassMenores; i++) {
      const arrSelect = {};
      arrSelect["code"] = i;
      arrSelect["description"] = i;
      response.push(arrSelect);
    }

    return response;
  };

  addEdad = (cantPass) => {
    this.setState((prevState) => {
      const cantAuxPass = this.state.cantPass;
      const array = [...prevState.edades];
      let cantidadPasajeros = cantPass - cantAuxPass;

      for (var i = 0; i < Math.abs(cantidadPasajeros); i++) {
        if (cantidadPasajeros > 0) {
          const ageCant = {};
          ageCant["ageInput"] = "";
          array.push(ageCant);
        } else {
          array.pop();
        }
      }
      return { cantPass: cantPass, edades: array };
    });
  };

  agesValue = (evt) => {
    this.setState((prevState) => {
      return {
        edades: [...prevState.edades, { ageInput: evt.target.value }],
      };
    });
  };

  handleCantPasajeros = (value, tipo) => {
    this.setState((prevState) => {
      prevState.adultos = tipo === "adultos" ? value : prevState.adultos;
      prevState.jovenes = tipo === "jovenes" ? value : prevState.jovenes;
      prevState.menores = tipo === "menores" ? value : prevState.menores;
      tipo === "menores" && this.addEdad(value);

      let total = prevState.adultos + prevState.jovenes + prevState.menores;
      let total1 = prevState.jovenes + prevState.menores;
      let total2 = prevState.adultos + prevState.menores;
      let total3 = prevState.adultos + prevState.jovenes;

      return {
        adultos: prevState.adultos,
        jovenes: prevState.jovenes,
        menores: prevState.menores,
        cantPassAdultos: total < 10 ? 10 - total1 : 9,
        cantPassJovenes: total < 10 ? 10 - total2 : 9,
        cantPassMenores: total < 10 ? 10 - total3 : 9,
        msgPassenger: total != 0 ? false : true,
      };
    });
  };

  handleSwapCities = (indice) => {
    let tramo = this.state.tramos[indice];
    let tramos = this.state.tramos;

    if (tramo.cityFrom && tramo.cityTo) {
      let varTramoIda = tramo.cityFrom;
      let varTramoVuelta = tramo.cityTo;

      tramo.cityFrom = varTramoVuelta;
      tramo.cityTo = varTramoIda;

      tramos[indice] = tramo;

      if (this.inputsReftOrigin[indice].current) {
        this.inputsReftOrigin[indice].current.value = tramo.cityFrom.value;
      }

      if (this.inputsReftDestination[indice].current) {
        this.inputsReftDestination[indice].current.value = tramo.cityTo.value;
      }
    }
  };

  render() {
    const {
      tramos,
      /* passengersSelected,
            edades,
            timeInput,
            departureInput,
            ages, */
    } = this.state;

    const autocomplete = this.props.autocomplete;
    //const edadesDisabled = 3

    const GetEdades = (edades) => {
      return (
        <Fragment>
          <div className="edades-container-wrapper">
            {edades.edades.length > 0 && (
              <Typography
                color="secondary"
                display="block"
                style={{ fontSize: 12 }}
              >
                Ingresa la edad de los pasajeros
              </Typography>
            )}
            <div className="edades-container">
              {edades.edades.length > 0 &&
                edades.edades.map((edad, i) => {
                  let ageInput = `ageInput-${i}`;
                  return (
                    <div key={i} className={`edad edad-${ageInput} edad-col`}>
                      <FormInputRangeAge
                        placeholder="Edad"
                        id={ageInput}
                        name={ageInput}
                        classnamecustom={"edad"}
                        autoComplete={"off"}
                        type={"number"}
                        //  defaultValue={edad.ageInput}
                        defaultValue={
                          this.state.ages[i]
                            ? this.state.ages[i].state.defaultValue !== ""
                              ? this.state.ages[i].state.defaultValue
                              : edad.ageInput
                            : edad.ageInput
                        }
                        onChange={this.agesValue}
                        ref={(element) => {
                          this.state.ages[i] = element;
                        }}
                        size="small"
                      />
                    </div>
                  );
                })}
            </div>
            <Typography
              className="passenger-leyend"
              color="secondary"
              variant="caption"
              display="block"
            >
              (Max. 9 pasajeros)
            </Typography>
          </div>
        </Fragment>
      );
    };

    const GetButton = (props) => {
      const loading = this.state.loading;

      return (
        <Fragment>
          <div
            className={`containerButtonProgress containerButtonProgressSearch`}
          >
            <div className={`wrapperButtonProgress`}>
              <Button
                disabled={loading}
                type="submit"
                fullWidth
                variant="contained"
                color="secondary"
                className="buttonSearch"
              >
                Buscar
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  color="inherit"
                  className={`buttonProgress`}
                />
              )}
            </div>
          </div>
        </Fragment>
      );
    };

    const showAddTramo = this.state.roundtrip ? "hidden" : "visible";

    return (
      <div className="container_buscador" m={1}>
        <form className={`form-search-trains`} onSubmit={this.handleSubmit}>
          <div className="flex filters-search">
            <FormLabel component="legend">
              <span style={{ fontWeight: "normal", marginRight: 5 }}></span>{" "}
              Tipo de Viaje:
            </FormLabel>

            {this.state.showDirectBtn && (
              <FormGroup className="formgroup-switch-directonly" row>
                <FormControlLabel
                  control={
                    <CheckboxForm
                      name="switchDirectOnly"
                      checked={this.props.directOnly}
                      onChange={(e) => this.handleDirectOnlyChange(e)}
                    />
                  }
                  label={<Typography>Trenes Directos</Typography>}
                />
              </FormGroup>
            )}

            <FormGroup className="formgroup-switch-optiontype" row>
              <FormControlLabel
                control={
                  <CheckboxForm
                    name="switchOptionType"
                    checked={this.state.roundtrip}
                    onChange={(e) => this.handleSwitchOptionType(e)}
                  />
                }
                label={<Typography>Ida y Vuelta</Typography>}
              />
            </FormGroup>
          </div>

          <Grid container spacing={1}>
            <Grid item md={11}>
              <div className={`cont-tramos`}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={9} className="col-dates">
                    <div className="container">
                      {tramos.map((tramo, index) => {
                        if (tramos[index] !== undefined) {
                          let tramoId = `tramo-${index}`,
                            cityFrom = `cityFrom-${index}`,
                            cityTo = `cityTo-${index}`,
                            dateFrom = `dateFromInput-${index}`,
                            dateTo = `dateToInput-${index}`;
                          const PopperAutocomplete = function (props) {
                            return (
                              <Popper
                                className="popper-autocomplete"
                                {...props}
                                style={{ width: 220 }}
                                placement="bottom-start"
                              />
                            );
                          };

                          return (
                            <div key={index} className={`tramo ${tramoId}`}>
                              {tramo?.iataFrom}
                              <Hidden smDown>
                                <div className="numeroTramo">{index + 1}</div>
                              </Hidden>
                              <Grid container spancing={1}>
                                <Grid item xs={12}>
                                  <Grid container spacing={1}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      className={`cols-autocomplete cols-autocomplete-searchtrains`}
                                    >
                                      <Grid container spacing={0}>
                                        <Grid
                                          item
                                          xs={6}
                                          style={{
                                            position: "relative",
                                            paddingRight: 20,
                                          }}
                                        >
                                          <Autocomplete /* freeSolo */
                                            id={cityFrom}
                                            defaultValue={""}
                                            /*  ref={element => { this.state.tramos[index]. = element }} */
                                            PopperComponent={PopperAutocomplete}
                                            //noOptionsText="Buscar"
                                            options={autocomplete}
                                            groupBy={(option) =>
                                              option.category
                                            }
                                            getOptionLabel={(option) => {
                                              if (option !== "") {
                                                let options =
                                                  option.label.split("|");
                                                this.optionHidden =
                                                  options[1] + "-" + options[2];
                                                return options[0];
                                              } else {
                                                if (tramo?.cityFrom) {
                                                  this.optionHidden =
                                                    tramo.cityFrom.code +
                                                    "-" +
                                                    tramo.cityFrom.type;
                                                  return tramo.cityFrom.value;
                                                }
                                              }
                                              return option
                                            }}
                                            onInputChange={(e, option) => {
                                              this.handleChangeAutoComplete(
                                                e,
                                                "cityFrom",
                                                index,
                                                option
                                              );
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                inputRef={this.inputsReftOrigin[index]}
                                                className={`InputForm`}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                fullWidth
                                                variant="outlined"
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: "off", // disable autocomplete and autofill
                                                }}
                                                name={cityFrom}
                                                label="Origen"
                                                placeholder="Ingrese una ciudad"
                                              />
                                            )}
                                          />
                                          <IconButton
                                            aria-label="change"
                                            className="search-stations-switcher"
                                            onClick={(ref) => this.handleSwapCities(index)}
                                          >
                                            <Icon>swap_horiz</Icon>
                                          </IconButton>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={6}
                                          style={{
                                            position: "relative",
                                            paddingLeft: 20,
                                          }}
                                        >
                                          <Autocomplete /* freeSolo */
                                            id={cityTo}
                                            PopperComponent={PopperAutocomplete}
                                            defaultValue={""}
                                            //noOptionsText="Buscar"
                                            groupBy={(option) =>
                                              option.category
                                            }
                                            options={autocomplete}
                                            getOptionLabel={(option) => {
                                              if (option !== "") {
                                                let options =
                                                  option.label.split("|");
                                                this.optionHidden =
                                                  options[1] + "-" + options[2];
                                                return options[0];
                                              } else {
                                                if (tramo?.cityTo) {
                                                  this.optionHidden =
                                                    tramo.cityTo.code +
                                                    "-" +
                                                    tramo.cityTo.type;
                                                  return tramo.cityTo.value;
                                                }
                                              }
                                              return option;
                                            }}
                                            onInputChange={(
                                              e,
                                              newInputValue
                                            ) => {
                                              this.handleChangeAutoComplete(
                                                e,
                                                "cityTo",
                                                index,
                                                newInputValue
                                              );
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                inputRef={this.inputsReftDestination[index]}
                                                className={`InputForm`}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                fullWidth
                                                variant="outlined"
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: "off", // disable autocomplete and autofill
                                                }}
                                                name={cityTo}
                                                label="Destino"
                                                placeholder="Ingrese un destino"
                                              />
                                            )}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={this.state.roundtrip ? 3 : 6}
                                      className={`cols-datepicker-timeselect`}
                                    >
                                      <Grid container spacing={1}>
                                        <Grid item xs={6} md={7}>
                                          <Datepicker
                                            id={dateFrom}
                                            name={dateFrom}
                                            label="Salida"
                                            departureValue={
                                              tramos[index - 1]?.departure
                                            }
                                            defaultValue={
                                              tramos[index]?.departure
                                            }
                                            callbackValue={(date) =>
                                              this.callback(
                                                date,
                                                index,
                                                "departure"
                                              )
                                            }
                                            ref={(element) => {
                                              this.state.departureInput[index] =
                                                element;
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={6} md={5}>
                                          <FormInputSelect
                                            id={`${"timeInput-"}${index}`}
                                            name={`${"timeInput-"}${index}`}
                                            ref={(element) => {
                                              this.state.timeInput[index] =
                                                element;
                                            }}
                                            label="Hora"
                                            defaultValue={tramo?.time}
                                            callbackValue={(time) =>
                                              this.callback(time, index, "time")
                                            }
                                            optionsSelect={getSearchDepartureHour()}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    {this.state.roundtrip && (
                                      <Grid
                                        item
                                        xs={12}
                                        md={3}
                                        className="cols-datepicker-timeselect"
                                      >
                                        <Grid container spacing={1}>
                                          <Grid item xs={6} md={7}>
                                            <Datepicker
                                              id={dateTo}
                                              name={dateTo}
                                              label="Regreso"
                                              dateToValue={
                                                tramos[index]?.departure
                                              }
                                              // defaultValue={
                                              //   tramos[index]?.departure
                                              // }
                                              callbackValue={(date) =>
                                                this.callback(
                                                  date,
                                                  index,
                                                  "dateTo"
                                                )
                                              }
                                              ref={(element) => {
                                                this.state.dateToInput[index] =
                                                  element;
                                              }}
                                            />
                                          </Grid>
                                          <Grid item xs={6} md={5}>
                                            <FormInputSelect
                                              id={`${"timeInputDateTo-"}${index}`}
                                              name={`${"timeInputDateTo-"}${index}`}
                                              ref={(element) => {
                                                this.state.timeInputDateTo[
                                                  index
                                                ] = element;
                                              }}
                                              label="Hora"
                                              defaultValue={tramo?.time}
                                              callbackValue={(time) =>
                                                this.callback(
                                                  time,
                                                  index,
                                                  "timeDateTo"
                                                )
                                              }
                                              optionsSelect={getSearchDepartureHour()}
                                            />
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                              {index > 0 && (
                                <IconButton
                                  onClick={() =>
                                    this.removeTramo(tramos, index)
                                  }
                                  aria-label="delete"
                                  className="button-delete"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              )}
                            </div>
                          );
                        }
                      })}
                    </div>
                  </Grid>
                  <Grid item xs={12} md={3} className="col-passengers">
                    <Grid container spacing={1}>
                      <Grid item xs={4} className="col-picker-number">
                        <FormInputSelect
                          id={`${"jovenes"}`}
                          name={`${"jovenes"}`}
                          // ref={element => { this.state.jovenes = element }}
                          label="Adulto"
                          //value={this.state.jovenes}
                          defaultValue={this.state.jovenes}
                          // callbackValue={}
                          callbackValue={(select) =>
                            this.handleCantPasajeros(select, "jovenes")
                          }
                          //optionsSelect={this.getSearchSelectJovenes()}
                          optionsSelect={this.getSearchSelectJovenes()}
                        />
                        <Typography variant="caption" display="block">
                          (30 a 59 años)
                        </Typography>
                      </Grid>
                      <Grid item xs={4} className="col-picker-number">
                        <FormInputSelect
                          id={`${"adultos"}`}
                          name={`${"adultos"}`}
                          //  ref={element => { this.state.adultos = element }}
                          label="Senior"
                          defaultValue={this.state.adultos}
                          // value={this.state.adultos}
                          // callbackValue={}
                          callbackValue={(select) =>
                            this.handleCantPasajeros(select, "adultos")
                          }
                          //optionsSelect={this.getSearchSelectAdultos()}
                          optionsSelect={this.getSearchSelectAdultos()}
                        />
                        <Typography variant="caption" display="block">
                          (desde 60 años)
                        </Typography>
                      </Grid>
                      <Grid item xs={4} className="col-picker-number">
                        <FormInputSelect
                          id={`${"menores"}`}
                          name={`${"menores"}`}
                          // ref={element => { this.state.menores = element }}
                          label="Menor/Joven"
                          defaultValue={this.state.menores}
                          // value={this.state.menores}
                          callbackValue={(select) =>
                            this.handleCantPasajeros(select, "menores")
                          }
                          //optionsSelect={this.getSearchSelectMenores()}
                          optionsSelect={this.getSearchSelectMenores()}
                        />
                        <Typography variant="caption" display="block">
                          (hasta 29 años)
                        </Typography>
                      </Grid>
                      <Grid item xs={12} className="col-passengers">
                        <GetEdades edades={this.state.edades} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>

              <div className="cont-controls">
                {tramos.length <= 7 && (
                  <Button
                    startIcon={<Icon>add_box</Icon>}
                    className="buttonLink"
                    color="secondary"
                    size="small"
                    onClick={this.addTramo}
                    style={{ visibility: showAddTramo }}
                  >
                    {" "}
                    Agregar tramo
                  </Button>
                )}

                {/*  {tramos.length > 1 && 
                                    <Button startIcon={<Icon>indeterminate_check_box</Icon>} className="buttonLink" color="secondary" size="small"
                                        > Eliminar tramo
                                    </Button>
                                } */}
              </div>
            </Grid>

            <Grid item xs={12} md={1}>
              <GetButton />

              {this.state.msgPassenger && (
                <Typography
                  className="passenger-validation-message"
                  variant="h4"
                >
                  Debe seleccionar al menos un pasajero{" "}
                </Typography>
              )}
              {this.state.msg && (
                <Typography
                  className="passenger-validation-message"
                  variant="h4"
                >
                  Debe completar todos los campos{" "}
                </Typography>
              )}
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers.homeReducer;
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetAutocomplete: (query, apiUrl) =>
      dispatch(getAutocompleteAction(query, apiUrl)),
    dispatchSaveRequest: (request) => dispatch(saveRequestAction(request)),
    dispatchGetRestore: () => dispatch(getRestore()),
    /*  dispatchRemove: (request) =>
             dispatch(
                 removeAction(
                     request
                 ),
             ), 
         dispatchAddSeg: (request) =>
             dispatch(
                 addSegAction(
                     request
                 ),
             )     
              */
    dispatchGetSearch: (
      origin,
      destination,
      departure,
      time,
      ages,
      tramos,
      tokenClient,
      apiToken,
      directOnly
    ) => {
      dispatch(
        getSearchAction(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          tokenClient,
          apiToken,
          directOnly
        )
      );
    },

    dispatchSaveFirstSearchData: (
      origin,
      destination,
      departure,
      time,
      ages,
      tramos,
      tokenClient,
      apiToken,
      directOnly
    ) => {
      dispatch(
        saveFirstSearchData(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          tokenClient,
          apiToken,
          directOnly
        )
      );
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchTrainsTickets)
);
